/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Typography from '@common_typography';
import Link from 'next/link';
import React from 'react';
import cx from 'classnames';

import Show from '@common/Show';
import dynamic from 'next/dynamic';

const CmsRenderer = dynamic(() => import('@core_modules/cms/components/cms-renderer'));

const Detail = (props) => {
    const {
        handleClick,
        name,
        storeConfig = {},
        seller,
        urlKey,
        showShortDescription = false,
        short_description,
        Pricing,
        isGrid = true,
        enableProductName = true,
        brandName,
    } = props;
    const enableMultiSeller = storeConfig.enable_oms_multiseller === '1' || storeConfig.enable_oms_multiseller === 1;

    let shortDescription = '';

    if (typeof short_description === 'string') {
        shortDescription = '';
    } else if (short_description) {
        shortDescription = short_description.html;
    }

    return (
        <div className="flex flex-col gap-1 relative w-full">
            <Show when={enableMultiSeller && seller && seller?.seller_name}>
                <Link href={`/seller/${seller?.seller_path}`}>
                    <Typography
                        variant="bd-2"
                        className={cx(
                            'line-clamp-1 capitalize',
                            'leading-5',
                            isGrid && 'text-sm tablet:text-base',
                            !isGrid && 'text-xs tablet:text-base',
                        )}
                        color="text-primary"
                    >
                        {seller?.seller_name || ''}
                    </Typography>
                </Link>
            </Show>
            <Show when={enableProductName}>
                <div className="text-center product-brand tracking-widest text-sm text-neutral-150 uppercase min-h-[20px]">
                    {brandName}
                </div>
            </Show>
            <Show when={enableProductName}>
                <Link href="/[...slug]" as={`/${urlKey}`} className="w-full plugin-productTitle-typography" onClick={() => handleClick(props)}>
                    <Typography
                        className={cx(
                            'font-medium line-clamp-2 capitalize text-center',
                            isGrid && 'text-[14px] tablet:text-[14px]',
                            !isGrid && 'text-sm tablet:text-[16px]',
                            'leading-normal !text-neutral-500 font-semibold',
                        )}
                    >
                        {name}
                    </Typography>
                </Link>
            </Show>
            <Show when={showShortDescription && shortDescription && !isGrid}>
                <div className="hidden tablet:flex !line-clamp-2 text-base text-neutral-500 leading-5">
                    <CmsRenderer content={shortDescription} />
                </div>
            </Show>
            {Pricing}
        </div>
    );
};

export default Detail;
